import { PageHero } from "@/components/PageHero";
import { SectionHeading } from "@/components/SectionHeading";
import { aboutCards } from "@/data/site";
import { useI18n } from "@/i18n/I18nProvider";

export function About() {
  const { t } = useI18n();

  return (
    <>
      <PageHero title={t("about.hero.title")} body={t("about.hero.body")} image="/concepts/aurel-colony-concept.png" />

      <section className="content-band">
        <div className="section-inner split-layout">
          <div data-reveal>
            <p className="eyebrow">{t("brand.title")}</p>
            <h2>{t("about.game.title")}</h2>
            <p>{t("about.game.body")}</p>
          </div>
          <div className="statement-panel" data-reveal>
            <strong>{t("brand.subtitle")}</strong>
            <span>{t("common.pcFirst")}</span>
            <span>{t("common.godot")}</span>
            <span>{t("common.pixelArt")}</span>
            <span>{t("common.singlePlayer")}</span>
          </div>
        </div>
      </section>

      <section className="content-band parchment-band">
        <div className="section-inner">
          <SectionHeading title={t("about.studio.title")} body={t("about.studio.body")} />
          <div className="info-strip">
            {aboutCards.map((card) => {
              const Icon = card.icon;
              return (
                <article className="feature-card" key={card.titleKey} data-reveal>
                  <Icon size={24} />
                  <h3>{t(card.titleKey)}</h3>
                  <p>{t(card.bodyKey)}</p>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      <section className="content-band">
        <div className="section-inner narrow-copy" data-reveal>
          <h2>{t("about.values.title")}</h2>
          <p>{t("about.values.body")}</p>
        </div>
      </section>
    </>
  );
}
